import { storageGet } from '../libs/localStorage';

export default async (productId) => {
  const favoritesListObject = storageGet('favorites');
  if (favoritesListObject) {
    if (Object.keys(favoritesListObject).includes(`${productId}`)) return false;
  }

  const queryString = new URLSearchParams({
    id: productId,
  });
  const response = await fetch(`/local/ajax/favorites/addItem.php?${queryString}`, {
    method: 'PUT',
  });
  if (response.ok) {
    const result = await response.json();
    window.updateFavoritesItems(result);

    return true;
  }

  return false;
};
